import { Urls } from "./urls";
import { Requester } from "./requester";
import { PushNotifications } from "./push-notifications";
import { Helper } from "./helper";

export class AuthenticationHandler
{
    static readonly controlTokenParamName = "wct";

    static async isLoggedIn(): Promise<boolean>
    {
        if (localStorage[AuthenticationHandler.controlTokenParamName])
        {
            try
            {
                const shouldLogout = <boolean> await Requester.get(Urls.authenticationShouldLogOut);
                if (shouldLogout)
                {
                    await this.logout();
                    return false;
                }
            }
            catch (e)
            {
                return false;
            }
            return true;
        }
        return false;
    }

    static async logout()
    {
        let oneSignalId: string | null = null;

        if (Helper.hasMedianOneSignal())
        {
            try
            {
                const oneSignalInfo = await (window as any).median.onesignal.onesignalInfo();
                oneSignalId = oneSignalInfo?.subscription?.id ?? null;
            }
            catch
            {
                oneSignalId = null;
            }
        }

        let endpoint: string | null = null;
        try
        {
            endpoint = await PushNotifications.unsubscribeAndGetEndpoint();
        }
        catch
        {
            endpoint = null;
        }

        localStorage.removeItem(AuthenticationHandler.controlTokenParamName);
        await Requester.get(Urls.authenticationLogOut, { pushToken: endpoint, oneSignalId: oneSignalId });

        if (Helper.isMedian())
        {
            window.location.href = "https://user.wemply.com";
        }
    }
}
